<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="pile_box">
          <el-row :gutter="10">
            <el-col :xs="8" :sm="6" :md="12" :lg="6" :xl="6" style="width: 20%;">
              <div class="pile_gun_item_box cos_box">
                <div class="box">
                  <div class="box_item box1"></div>
                  <div class="box_item box2"></div>
                  <div class="box3"></div>
                </div>
                <div class="cos_text">{{ detailsData.soc }}%</div>
              </div>
            </el-col>
            <el-col :xs="4" :sm="6" :md="12" :lg="6" :xl="6" style="width: 22%;">
              <div class="pile_gun_box">
                <div class="status_title">充电中</div>
                <ul>
                  <li>
                    <span>枪号</span>
                    {{ detailsData.gunCode }}
                  </li>
                  <li>
                    <span>用户</span>
                    {{ detailsData.phone }}
                  </li>
                  <li>
                    <span>持续时间</span>
                    {{ chargeTime(detailsData.totalTime) }}
                  </li>
                  <li>
                    <span>类型</span>
                    {{ gunType(detailsData.gunType) }}
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="4" :sm="6" :md="12" :lg="6" :xl="6" style="width: 33%;">
              <div class="pile_gun_box">
                <div class="status_title"></div>
                <ul>
                  <li>
                    <span>订单编号</span>
                    {{ detailsData.orderNo }}
                  </li>
                  
                  <li>
                    <span>开始时间</span>
                    {{ detailsData.startTime }}
                  </li>
                  <li>
                    <span>充电金额</span>
                    {{ detailsData.fee }}
                  </li>
                  <li>
                    <span>订单来源</span>
                    {{ source(detailsData.orderNo) }}
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :xs="8" :sm="6" :md="12" :lg="6" :xl="6">
              <div style="position: relative">
                <div id="electricChart" class="electricChart"></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="24">
        <div style="width: 100%">
          <div style="width: 100%; height: 300px" id="batteryChart"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Chart from "echarts";
// import { chart } from 'highcharts';
export default {
  name: "chargingMonitorDetails",
  props: {
    detailsData: {
      type: Object,
      required: {},
    },
    lineChartLength: {
      type: Number,
      required: 10,
    },
  },
  data() {
    return {
      echartsData: {},
      batteryChart: null,
      electricChart: null,
    };
  },
  computed: {
    gunType: function () {
      return function (gunType) {
        console.log("gunType:" + gunType);
        if (gunType === "S") {
          return "交流";
        } else if (gunType === "F") {
          return "直流";
        } else {
          return "未知";
        }
      };
    },
    startType: function () {
      return function (startType) {
        if (startType === "0") {
          return "刷卡启动";
        } else if (startType === "1") {
          return "扫码启动";
        }else if(startType === 3){
          return "扫码启动";
        } else {
          return "未启动";
        }
      };
    },
    chargeTime: function () {
      return function (totalTime) {
        let chargeMin = Math.floor(totalTime / 60);
        let chargeSecond = totalTime % 60;
        let chargeHour = Math.floor(chargeMin / 60);
        chargeMin = chargeMin % 60;
        chargeMin = chargeMin > 10 ? chargeMin : "0" + chargeMin;
        chargeSecond = chargeSecond > 10 ? chargeSecond : "0" + chargeSecond;
        chargeHour = chargeHour > 10 ? chargeHour : "0" + chargeHour;
        return chargeHour + ":" + chargeMin + ":" + chargeSecond;
      };
    },
    source:function(e){
      return function(e){
        let source = e.substring(0,9)
        if(source == 'MA005DBW1'){
          return '快电'
        }else if(source == 'MA5FF58R7'){
          return '星络'
        }else if(source == 'MAC1F3P25'){
          return '加电'
        }else if(source == 'MA25CNM38'){
          return '新电途'
        }else{
          return '充小兽'
        }
      }
    }
  },
  watch: {
    detailsData(detailsData) {
      // if (detailsData) {
      //   this.echartsData = detailsData;
      //   if (detailsData.timeData.length > 0) {
      this.initBatteryChart();
      //   }
      // }
    },
  },
  created() {},
  mounted() {
    this.batteryChart = Chart.init(document.getElementById("batteryChart"));
    this.electricChart = Chart.init(document.getElementById("electricChart"));
    this.initBatteryChart();
    this.initElectricChart();
    window.onresize = () => {
      return (() => {
        this.batteryChart.resize();
        this.electricChart.resize();
      })();
    };
  },
  methods: {
    initElectricChart() {
      this.electricChart.setOption({
        tooltip: {
          formatter: "{a} <br/>{b}充电温度 : {c}℃",
        },
        toolbox: {
          feature: {
            // restore: {},
            // saveAsImage: {},
          },
        },
        series: [
          {
            name: "当前温度",
            type: "gauge",
            min: -50,
            max: 150,
            detail: { fontSize: 20, formatter: "{value}℃" },
            data: [{ value: this.detailsData.temperature }],
            splitLine: {
              length: 6,
              lineStyle: {
                width: 2,
                color: "#999",
              },
            },
            axisLine: {
              lineStyle: {
                width: 4,
                color: [
                  [0.25, "#4dabf7"],
                  [0.7, "#69db7c"],
                  [1, "#ff6b6b"],
                ],
              },
            },
          },
        ],
      });
    },
    initBatteryChart() {
      let voltageData = this.detailsData.voltageData;
      let currentData = this.detailsData.currentData;
      let powerData = this.detailsData.powerData;
      let timeData = this.detailsData.timeData;
      if (timeData && timeData.length < 10) {
        let data = [];
        for (let i = 0; i < 10 - timeData.length; i++) {
          data.push("*");
        }
        timeData = [...timeData, ...data];
      }
      console.log(timeData);
      this.batteryChart.setOption({
        title: {
          text: "充电情况实时监控",
          left: "20",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          top: 20,
          icon: "rect",
          itemWidth: 14,
          itemHeight: 5,
          itemGap: 13,
          data: ["电流", "电压", "功率"],
          right: "4%",
          textStyle: {
            fontSize: 12,
          },
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#57617B",
              },
            },
            data: timeData,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "电流",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            areaStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(137, 189, 27, 0.3)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(137, 189, 27, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10,
              },
            },
            itemStyle: {
              normal: {
                color: "rgb(137,189,27)",
                borderColor: "rgba(137,189,2,0.27)",
                borderWidth: 12,
              },
            },
            data: currentData,
          },
          {
            name: "电压",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            areaStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0, 136, 212, 0.3)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(0, 136, 212, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10,
              },
            },
            itemStyle: {
              normal: {
                color: "rgb(0,136,212)",
                borderColor: "rgba(0,136,212,0.2)",
                borderWidth: 12,
              },
            },
            data: voltageData,
          },
          {
            name: "功率",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            areaStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(219, 50, 51, 0.3)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(219, 50, 51, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)",
                shadowBlur: 10,
              },
            },
            itemStyle: {
              normal: {
                color: "rgb(219,50,51)",
                borderColor: "rgba(219,50,51,0.2)",
                borderWidth: 12,
              },
            },
            data: powerData,
          },
        ],
      });
    },
  },
};
</script>

<style lang="less" scoped>
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
}

.pile_box {
  padding-left: 30px;
  box-sizing: border-box;
  padding-bottom: 60px;

  .pile_gun_item_box {
    margin-top: 30px;
    transform: translateX(30px);
  }

  .electricChart {
    width: 200px;
    height: 200px;
    position: absolute;
    top: -15px;
    left: 40px;
    z-index: 999;
  }
  .icon {
    transform: rotateY(-180deg);

    .icon-chongdianqiang {
      font-size: 40px;
      color: #ce1219 !important;
    }
  }

  .pile_gun_box {
    text-align: left;

    .status_title {
      color: #0081ff !important;
      height: 25px;
      line-height: 25px;
    }

    ul {
      display: block;

      li {
        color: #000;
        height: 25px;
        line-height: 25px;
        font-size: 13px;

        span {
          display: inline-block;
          width: 65px;
          color: #737780;
        }
      }
    }
    // div {
    //
    // }

    div:first-child {
      color: #000;
    }
  }
}
// .chart_item,
// #batteryChart {
//   width: 100%;
//   height: 300px;
// }

/*旋转动画*/
@keyframes moveover {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.cos_box {
  position: relative;
  top: -20px;
  width: 100px;
  height: 100px;
  .box {
    width: 100%;
    height: 100%;

    /*整体旋转*/
    animation: moveover 2.5s linear infinite;

    .box_item {
      position: absolute;
      width: 50px;
      height: 100px;
    }

    .box1 {
      border-radius: 50px 0 0 50px;
      /* 起始最深颜色为 #999，过渡到中间颜色为 #d0cfcf */
      background: linear-gradient(#0081ff, rgba(0, 129, 255, 0.5));
      z-index: 2;
    }
    .box2 {
      border-radius: 0 50px 50px 0;
      left: 50%;
      /* 过渡到中间颜色为 #d0cfcf 最终末尾颜色为 #eee */
      background: linear-gradient(#fff, rgba(0, 129, 255, 0.5));
      z-index: 1;
    }

    .box3 {
      position: absolute;
      width: 92px;
      height: 92px;
      top: 4px;
      left: 4px;
      border-radius: 50%;
      background-color: #fff;
      z-index: 2;
    }
  }
  .cos_text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #000;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/component/chargingMonitorDetails.vue